import { DateFormatType } from '@/modules/core/domain/interfaces';
import { MenuGroup, MenuOptionGroup } from '@chakra-ui/react';
import DatePicker from '@components/Date';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';

import { DateProps } from '../../../../interfaces';
import { QueryDateModel } from './localGeneric';
import { DateContainer } from './styles';

const ChakraRangeDateFilter: React.FC<DateProps> = ({
  title,
  onSelect,
  isRange,
  selected,
  dateFormat,
  initialSelected,
}) => {
  const [dateStart, setDateStart] = useState<string>(() => {
    if (initialSelected && typeof initialSelected === 'string') {
      return `${moment(initialSelected).utc().unix()}`;
    }

    if (
      initialSelected &&
      typeof initialSelected === 'object' &&
      initialSelected.dateStart
    ) {
      return `${moment(initialSelected.dateStart).utc().unix()}`;
    }

    return '';
  });
  const [dateEnd, setDateEnd] = useState<string>(
    initialSelected &&
      typeof initialSelected === 'object' &&
      initialSelected.dateEnd
      ? `${moment(initialSelected.dateEnd).utc().unix()}`
      : '',
  );
  const [query, setQuery] = useState<string | QueryDateModel>();

  const onGetDateStart = useCallback(
    (newDate: string) => {
      if (!isRange) {
        setDateStart(newDate);
        onSelect(newDate);
        return;
      }
      const newQuery: QueryDateModel = { ...(query as QueryDateModel) };
      const parsedDate: string =
        dateFormat === DateFormatType.DEFAULT_TIMESTAMP
          ? newDate
          : moment(Number(newDate) * 1000).format('YYYY-MM-DD');

      newQuery.dateStart = parsedDate;
      onSelect(newQuery);
      setDateStart(newDate);
    },
    [dateFormat, isRange, onSelect, query],
  );

  const onGetDateEnd = useCallback(
    (newDate: string) => {
      setDateEnd(newDate);
      const newQuery: QueryDateModel = { ...(query as QueryDateModel) };
      const parsedDate: string =
        dateFormat === DateFormatType.DEFAULT_TIMESTAMP
          ? newDate
          : moment(Number(newDate) * 1000).format('YYYY-MM-DD');

      newQuery.dateEnd = parsedDate;
      onSelect(newQuery);
      setDateEnd(newDate);
    },
    [dateFormat, onSelect, query],
  );

  const resetData = useCallback(() => {
    setDateEnd('');
    setDateStart('');
    setQuery('');
  }, []);

  useEffect(() => {
    if (!selected) {
      resetData();
      return;
    }
    setQuery(selected);
  }, [selected, resetData]);

  useEffect(() => {
    if (selected) {
      if (selected.dateStart)
        setDateStart(`${moment(selected.dateStart).utc().unix()}`);
      if (selected.dateEnd)
        setDateEnd(`${moment(selected.dateEnd).utc().unix()}`);

      if (selected.dateStart && !selected.dateEnd)
        onGetDateEnd(moment().utc().unix().toString());
    }
  }, [onGetDateEnd, selected]);

  return (
    <MenuGroup>
      <MenuOptionGroup title={title}>
        <DateContainer isColumn>
          <>
            <DatePicker
              title=""
              date={dateStart}
              dateFormat={dateFormat}
              onSelect={onGetDateStart}
            />
          </>
        </DateContainer>
      </MenuOptionGroup>
      <MenuOptionGroup title="Até:">
        <DateContainer isColumn>
          <>
            <DatePicker
              title=""
              dateFormat={dateFormat}
              onSelect={onGetDateEnd}
              date={dateEnd}
              minDate={dateStart}
            />
          </>
        </DateContainer>
      </MenuOptionGroup>
    </MenuGroup>
  );
};

export default ChakraRangeDateFilter;
